import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 5h9a3 3 0 0 1 3 3v8a3 3 0 0 1 -.13 .874m-2.006 2a3 3 0 0 1 -.864 .126h-12a3 3 0 0 1 -3 -3v-8c0 -1.35 .893 -2.493 2.12 -2.869","key":"svg-0"}],["path",{"d":"M7 15h5","key":"svg-1"}],["path",{"d":"M17 12h-1","key":"svg-2"}],["path",{"d":"M12 12h-2","key":"svg-3"}],["path",{"d":"M3 3l18 18","key":"svg-4"}]]

const IconSubtitlesOff = createReactComponent('outline', 'subtitles-off', 'SubtitlesOff', __iconNode);

export default IconSubtitlesOff;